import {
  HeatingCircuitTypes,
  HeatingSystemMetadata,
  TemperatureControlParameter,
} from '@/features/core/store/page-modules/heating-systems-metadata/heating-systems-metadata.module';

export function getTemperatureControlParameter(
  type: string | null,
  parameter: TemperatureControlParameter,
): TemperatureControlParameter {
  if (
    type === 'pointed_curve' &&
    Array.isArray(parameter.pointed_curve_parameter) &&
    parameter.pointed_curve_parameter.length > 0
  ) {
    return {
      type,
      pointed_curve_parameter: parameter.pointed_curve_parameter,
    };
  } else if (type === 'constant_temperature') {
    return {
      type,
      target_temperature: parameter.target_temperature,
    };
  } else {
    return {
      type: null,
      target_temperature: null,
      pointed_curve_parameter: [],
    };
  }
}
export function getFormDataForTeleHeating(
  formData: HeatingSystemMetadata['teleHeating'],
): HeatingSystemMetadata['teleHeating'] {
  return {
    ...formData,
    flow_temperature_control_parameter: getTemperatureControlParameter(
      formData.flow_temperature_control_parameter.type,
      formData.flow_temperature_control_parameter,
    ),
    return_temperature_control_parameter: getTemperatureControlParameter(
      formData.return_temperature_control_parameter.type,
      formData.return_temperature_control_parameter,
    ),
  };
}

export function getFormDataForHeatingCircuit(
  formData: HeatingSystemMetadata['heatingCircuit'],
): HeatingSystemMetadata['heatingCircuit'] {
  const controlParameter = formData.control_parameter;

  const baseControlParameter = {
    type: controlParameter.type,
    summer_shutdown_temp: controlParameter.summer_shutdown_temp,
    nightly_reduced_temperature: controlParameter.nightly_reduced_temperature,
    minimum_temperature: controlParameter.minimum_temperature,
    maximum_temperature: controlParameter.maximum_temperature,
    supply_potable_water_heating: controlParameter.supply_potable_water_heating,
  };

  let normalizedControlParameter: HeatingSystemMetadata['heatingCircuit']['control_parameter'];

  switch (controlParameter.type) {
    case HeatingCircuitTypes.POINTED_CURVE:
      normalizedControlParameter = {
        ...baseControlParameter,
        env_flow_temp_points: controlParameter.env_flow_temp_points,
      };
      break;
    case HeatingCircuitTypes.CONSTANT_TEMPERATURE:
      normalizedControlParameter = {
        ...baseControlParameter,
        target_temperature: controlParameter.target_temperature,
      };
      break;
    case HeatingCircuitTypes.PARAMETERIZED_CURVE:
      normalizedControlParameter = {
        ...baseControlParameter,
        room_target_temperature: controlParameter.room_target_temperature,
        offset: controlParameter.offset,
        slope: controlParameter.slope,
      };
      break;
    case HeatingCircuitTypes.AUTOMATIC:
    default:
      normalizedControlParameter = baseControlParameter as HeatingSystemMetadata['heatingCircuit']['control_parameter'];
  }

  return {
    ...formData,
    control_parameter: normalizedControlParameter,
  };
}
